<template>
  <v-app>

    <!-- <v-select
      v-model="selected"
      @change="setPlace(selected)"
      :items="this.getPlaceList()"
      label=selected
      solo
    ></v-select> -->

    <!-- 入力エリア -->
    <div class="input">

      <!-- カテゴリ -->
      <div class="input__category"
           v-for="(item, index) in selectedPlace.category"
           :key="index">

        <!-- カテゴリタイトル -->
        <div class="input__category__title">
          <span>{{item.name}}</span>
        </div><!-- input__category__title -->

        <!-- コメント -->
        <v-textarea
          v-if="item.name === 'コメント'"
          dense
          filled
          full-width
          auto-grow
          rows="2"
          clearable
          type="text"
          style="display: inline-block;" 
          :id="item.name"
          v-model="selectedData[index].value"
          @change="setSelectedData()"
        ></v-textarea>

        <!-- カテゴリ内の要素一覧 -->
        <div v-else class="input__category__params">
          <!-- カテゴリ内の各要素 -->
          <div class="input__category__params__param"
               v-for="(param, ind) in item.params"
               :key="ind"
               :style="{width: item.vw ? item.vw + '%' : '25%'}">
            <!-- 入力 -->
            <input
              type="radio"
              :id="item.name + ind + param"
              :value="param"
              v-model="selectedData[index].value"
            >
              <!-- @change="setSelectedData()"> -->
            <!-- 入力ラベル -->
            <label
              :for="item.name + ind + param"
              :style="{
                background: item.color && item.color[ind] ? item.color[ind] : 'rgba(0, 0, 0, 0.06)' }">
              {{ param }} 
            </label>
          </div><!-- input__category__params__param -->

        </div><!-- input__category__params -->

      </div><!-- input__category -->

    </div><!-- input -->

    <!-- 確認エリア -->
    <div class="confirm">

      <v-btn
        v-bind:disabled="isFilled"
        v-on:click="addResult"
        fab>
        <v-icon color="grey lighten-3">mdi-pencil</v-icon>
      </v-btn>

    </div><!-- confirm -->

    <!-- <v-select
      v-model="selected"
      @change="setPlace(selected)"
      :items="this.getPlaceList()"
      label=selected
      solo
    ></v-select> -->

  </v-app>
</template>

<script>
import moment from 'moment'
import _ from 'underscore'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  data: function () {
    return {
      storageData : [],
      selectedData : [],
      isShow : true,
      selected : 'CERO 2F α',
      gyms: ['CERO 2F', 'グリーンアリーナ'],

    }
  },
  created () {
    this.setPlace(this.selected)
    // this.$store.dispatch('SET_PLACE', this.selected)

    // Vuexに入力データがある場合はそちらを使用する
    if (!_.isEmpty(this.selectedTask)) {
      this.selectedData = JSON.parse(JSON.stringify(this.selectedTask))
    // ない場合はselectedPlace.categoryからparamasとvwを抜いたものを使用し、
    // それをselectedDataに入れる
    } else {
      // ※
      // javascriptにおいてオブジェクトのコピーは参照渡し(ポインタのやつ)になる
      // const targetObj = Object.assign({}, originalObj) という書き方では
      // originalObjがネストされたオブジェクトだった場合に対応できないため、
      // ここでは以下のようにjsonデータを一度文字列化して対応している。
      this.selectedData = JSON.parse(JSON.stringify(this.selectedPlace.category))
      for (const item in this.selectedData) {
        delete this.selectedData[item].params
        delete this.selectedData[item].color
        delete this.selectedData[item].vw
      }
    }
  },
  computed : {
    ...mapState({
      selectedTask: state => state.task.selectedTask,
      selectedPlace: state => state.places.selectedPlace
    }),

    isFilled () {
      // 2024/07/10 一時的にバリデーションを取っ払う
      // 
      // let bool = false
      // // 入力されたデータを取得して追加
      // this.selectedData.forEach(element => {
      //   if (element.name !== 'コメント' && element.value === '') {
      //     bool = true
      //   }
      // });
      // // this.isShow==true ? bool = false : bool = true;
      // return this.isShow&&bool ? true : false
      return false
    }
},
  methods: {
    ...mapGetters({
      getPlaceList: 'places/getPlaceList',
    }),
    ...mapMutations({
      setTask: 'task/setTask',
      updateStorageData: 'task/updateStorageData',
      syncStorageData: 'task/syncStorageData',
      setPlace: 'places/setPlace',
      setIsShowToast: 'task/setIsShowToast'
    }),
    ...mapActions({
      // setPlace: 'places/setPlace',
    }),

   // HOGE HOGE
    handleChangePlase: function(selected) {
      this.store.dispatch('setPlace', selected)
    },


    // 入力中の情報をvuexにセット
    setSelectedData: function() {
      this.setTask(this.selectedData)
    },

    // 結果の登録(追記)
    addResult: function() {
      const result = {};
      this.isShow = false;

      // タイムスタンプから一意なIDを生成して追加
      result.id = new Date().getTime().toString();

      // 現在時刻を取得して追加
      result.date = moment().format('YYYY/MM/DD');
      result.time = moment().format('HH:mm');

      // 場所(ジム等)を取得して追加
      // ※ ここは将来的に事前に登録した複数の場所(ジム等)から
      //    選択されたものになる想定(今は決め打ち)
      result.place = this.selectedPlace.name;

      // 入力されたデータを取得して追加
      this.selectedData.forEach(element => {
        result[element.name] = element.value
      });

      // 一度localStorageからデータを取得し、
      // そのデータの末尾に入力されたデータを追加してlocalStorageに登録
      if (localStorage.getItem("results")) {
        this.storageData = JSON.parse(localStorage.getItem("results"));
      } 
      this.storageData.push(result);
      this.updateStorageData(this.storageData)
      this.syncStorageData()
      this.$emit('updateTryCount');
      this.setIsShowToast()
      setTimeout(() => {this.isShow = true}, 1000)
    }
  } 
}
</script>

<style scoped lang="scss">
@import "colors.scss";
.input {
  padding: 5px;
  margin-bottom: 20px;
}

.input__category {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 15px;
}

.input__category__title {
  margin-bottom: -3px;
  font-size: 18px;
}

.input__category__params {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  width: 100%;
}

.input__category__params__param {
  width: calc(1/3)vw;
  padding: 2px;
}

.v-text-field { width: 100%; }

.v-btn--is-elevated{ background-color: $indigo !important; }

.confirm {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 96px;
  position: fixed;
  right: 10px;
  bottom: 44px;
}

input {
  display: none;
}

input[type="radio"]:checked + label {
  box-sizing: border-box;
  border: $indigo solid 4px;
}

label{
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  align-items: center;
  cursor: pointer;
  width: 100%;
  height: 25px;
  margin: 0;
  color: #000000;
  box-sizing: border-box;
  border-radius: 8px;
  font-size: 16px;
  line-height: 1;
  transition: .2s;
}

</style>